import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchStats } from '@uncinc/react-searchkit';
import type { SearchStatsProps } from '@uncinc/react-searchkit/dist/components/Stats';

import './style.scss';

const SearchPromotedContentThemesStats: React.FC<SearchStatsProps> = (props) => {
  const { className, ...restProps } = props;

  const { t } = useTranslation();

  const classNames = c('SearchPromotedContentThemes__Stats', className);

  return (
    <SearchStats
      {...restProps}
      className={classNames}
      translation={(numberOfHits: number) => t('components.search_promoted_content_themes.stats.total_results', { count: numberOfHits })}
    />
  );
};

export default SearchPromotedContentThemesStats;
